import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="brand-wrap">
        <p className="brand-overline">Company Site</p>
        <h1 className="navbar-logo">Brogverse</h1>
      </div>
      <ul className="navbar-links">
        <li>
          <Link to="/">Homepage</Link>
        </li>
        <li>
          <Link to="/status">Service Status</Link>
        </li>
        <li>
          <Link to="/redirects">Link Routing</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
